import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { useAuth } from 'src/modules/auth'
import { Messages } from 'src/modules/messages'

import { Admin } from '../modules/admin'
import { Invoices } from '../modules/invoices'
import { Purchasing } from '../modules/purchasing'
import { Suppliers } from '../modules/suppliers'
import { Recipes } from '../modules/recipes'
import { Inventory } from '../modules/inventory'
import { Profile } from 'src/modules/auth/components'

const Routing = () => {
  const { hasEnvironments, hasPermission } = useAuth()

  const redirect = hasPermission('view_approved_suppliers')
    ? '/suppliers'
    : hasEnvironments
    ? '/purchasing'
    : '/profile'

  return (
    <Switch>
      {hasPermission('view_approved_suppliers') && (
        <Route path="/suppliers" component={Suppliers} />
      )}
      <Route path="/invoices" component={Invoices} />
      <Route path="/products" component={Suppliers} />
      {hasEnvironments && <Route path="/purchasing" component={Purchasing} />}
      {hasEnvironments && <Route path="/recipes" component={Recipes} />}
      {hasEnvironments && <Route path="/inventory" component={Inventory} />}
      <Route path="/messages" component={Messages} />
      {hasPermission('admin') && <Route path="/admin" component={Admin} />}
      <Route path="/profile" component={Profile} />
      <Redirect to={redirect} />
    </Switch>
  )
}

export default Routing
